import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  addRangeOfDaysPayout,
  getCurrentDatePayout
} from '../../../../domain/features/ui/rangeOfDaysPayoutSlice'
import InputRangeDate from '../../atomics/Input/InputRangeDate'
import debounce from 'lodash/debounce'

/**
 * Componente funcional que renderiza un selector de rango de fechas.
 * Integra Redux para manejar el rango de fechas seleccionado.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.withborder - Determina si el selector debe tener un borde.
 *        - `true`: Aplica un borde alrededor del selector, útil para destacar el componente visualmente.
 *        - `false`: No aplica borde, útil para un diseño más minimalista.
 *
 * @returns {JSX.Element} El componente RangeOfDaysPayout renderizado.
 */
const RangeOfDaysPayout = ({ withborder }) => {
  const date = useSelector(getCurrentDatePayout)
  const dispatch = useDispatch()

  /**
   * Maneja el cambio de entrada de fecha con un mecanismo de debounce para limitar la frecuencia de despacho de acciones.
   *
   * @param {any} value - El valor que representa la fecha o rango de fechas a procesar.
   * @returns {void}
   */
  const handleDateChange = debounce(value => {
    if (value !== date) {
      dispatch(addRangeOfDaysPayout(value))
    }
  }, 300)

  /**
   * Handles the change event for a date input and updates the selected date value.
   *
   * @param {Object} event - The event object triggered by the input change.
   * @param {any} value - The new value of the date input.
   */
  const onChangeHandler = useCallback(
    (event, value) => {
      event.preventDefault() // Prevenir comportamiento predeterminado del evento
      handleDateChange(value)
    },
    [handleDateChange]
  )

  return (
    <InputRangeDate
      withborder={withborder}
      prefixName="Fecha Liquidación"
      value={date}
      onChange={onChangeHandler}
      aria-label="Selector de rango de fechas para la liquidación"
      aria-required="true"
    />
  )
}

export default RangeOfDaysPayout
